import { ShippingRestrictionsNotice } from "@/components/ShippingRestrictionsNotice";
import { NewsletterCapture } from "@/components/NewsletterCapture";

const footerGroups = [
  {
    label: "Shop",
    links: [
      { href: "/gummies", label: "All gummies" },
      { href: "/powders", label: "Powders" },
      { href: "/capsules", label: "Capsules" },
      { href: "/krypt", label: "KRYPT gummies" },
      { href: "/", label: "Featured products" },
      { href: "/about", label: "About Kratown" },
      { href: "/learn", label: "Learn" },
      { href: "/#faq", label: "FAQ" },
    ],
  },
  {
    label: "Help",
    links: [
      { href: "/contact", label: "Contact Kratown" },
      { href: "/shipping-policy", label: "Shipping policy" },
      { href: "/refund-policy", label: "Returns & refunds" },
    ],
  },
  {
    label: "Legal",
    links: [
      { href: "/shipping-restrictions", label: "Shipping restrictions" },
      { href: "/fda-disclaimer", label: "FDA disclaimer" },
      { href: "/terms", label: "Terms of service" },
      { href: "/privacy", label: "Privacy policy" },
    ],
  },
  {
    label: "Wholesale",
    links: [
      { href: "/wholesale", label: "Wholesale portal" },
      { href: "/wholesale/login", label: "Wholesale login" },
      { href: "/wholesale/apply", label: "Become a partner" },
    ],
  },
];

export function StorefrontFooter() {
  return (
    <footer className="border-t border-white/8 bg-[#05100e] py-12 text-white">
      <div className="container grid gap-10 xl:grid-cols-[0.72fr_1.28fr] xl:items-start">
        <div>
          <p className="font-serif text-3xl font-semibold tracking-[0.04em] text-white">KRATOWN</p>
          <p className="mt-3 max-w-sm text-sm leading-7 text-white/60">A focused shop for flavor-forward botanical goods and a clear, secure ordering experience.</p>
          <p className="mt-5 text-xs uppercase tracking-[0.18em] text-white/40">21+ only</p>
          <a href="/learn" className="mt-5 inline-flex text-sm font-medium text-[#d9ff8a] underline-offset-4 hover:underline">Learn before you order</a>
        </div>
        <div className="grid gap-8">
          <div className="grid gap-7 sm:grid-cols-2 lg:grid-cols-4">
            {footerGroups.map((group) => (
              <nav key={group.label} aria-label={group.label}>
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/45">{group.label}</p>
                <ul className="mt-4 space-y-3">
                  {group.links.map((link) => <li key={link.href}><a href={link.href} className="text-sm text-white/72 hover:text-[#d9ff8a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#c2ff45]">{link.label}</a></li>)}
                </ul>
              </nav>
            ))}
          </div>
          <ShippingRestrictionsNotice variant="footer" />
        </div>
      </div>
      <div className="container mt-10">
        <NewsletterCapture />
      </div>
      <div className="container mt-10 border-t border-white/8 pt-5 text-xs uppercase tracking-[0.14em] text-white/38">© {new Date().getFullYear()} Kratown. All rights reserved.</div>
    </footer>
  );
}
